import { UserOutlined } from '@ant-design/icons';
import MyChatBotIcon from 'assets/icons/MyChatBotIcon';
import {
  ChatBotIcon,
  SettingsIcon,
  ChatInterfaceIcon,
  SourceIcon,
  EmbedIcon,
  AccessibilityIcon,
  RobotIcon,
  LogOut,
  PricingIcon,
} from '../assets/icons';

/* Items to show in the sidebar/navbar */

export const DEFAULT_DRAWER_ITEMS = [
  {
    key: 'mychatbots',
    icon: <MyChatBotIcon />,
    label: 'My Chatbots',
    route: '/chatbots',
    state: {
      hideSideBar: false,
    },
  },
  {
    key: 'my-chatbot',
    icon: <SettingsIcon />,
    label: 'Chabot Settings',
    children: [
      {
        key: 'chatbot',
        icon: <RobotIcon />,
        label: 'Preview Chatbot',
        route: '/chatbot',
      },
      {
        key: 'conversations',
        icon: <ChatBotIcon />,
        label: 'Chat History',
        route: '/conversations',
      },
      {
        key: 'settings',
        icon: <SettingsIcon />,
        label: 'Bot Settings',
        route: '/settings',
      },
      {
        key: 'chat-interface',
        icon: <ChatInterfaceIcon />,
        label: 'Widget Settings',
        route: '/chat-interface',
      },
      {
        key: 'accessibility',
        icon: <AccessibilityIcon />,
        label: 'Access Control',
        route: '/access-control',
      },
      {
        key: 'source',
        icon: <SourceIcon />,
        label: 'Update Data Source',
        route: '/data-source',
      },
      {
        key: 'embed-on-site',
        icon: <EmbedIcon />,
        label: 'Add bot to your site',
        route: '/embed-on-site',
      },
    ],
  },
  {
    key: 'my-account',
    icon: <UserOutlined />,
    label: 'My Account',
    route: '/account',
  },
  {
    key: 'pricing',
    icon: <PricingIcon/>,
    label: 'Pricing',
    route: '/pricing',
  },
  {
    key: 'logout',
    icon: <LogOut />,
    label: 'Logout',
    route: '/logout',
  },
];
